import { ResourceType } from "@/game/entities/config/resources";
import { isMobile } from "@/utils/isMobile";

export enum RouteNames {
	LAYOUT_VIEW = "LayoutView",
	TILE = "Tile",
	QUESTS = "Quests",
	UPGRADES = "Upgrades",
	SHOP = "Shop",
	INFO = "Info",
	SETTINGS = "Settings",
	STORY = "Story",
}

export enum Avatars {
	NARRATOR = "Narrator",
	PLAYER = "Player",
	ADALBERT = "Adalbert",
	GERTRUDE = "Gertrude",
	LEONARD = "Leonard",
	LESTER = "Lester",
	MOIRA = "Moira",
	RUPERT = "Rupert",
	WALTER = "Walter",
	THRASIUS = "Thrasius",
	ESTHER = "Esther",
	GARRICK = "Garrick",
	GARRICK_THIEF = "Garrick_thief",
	VIVIANNE = "Vivianne",
}

export enum IconTypes {
	CLOSE = "close",
	INFO = "info",
	FILTER = "filter",
	SHOW = "show",
	HIDE = "hide",
	GRID = "grid",
	LIST = "list",
	PLAY = "play",
	EXPAND = "expand",
	COLLAPSE = "collapse",
	COPY = "copy",
	EDIT_LIGHT = "edit-light",
	EDIT_DARK = "edit-dark",
	PLAY_AD = "play-ad",
	SAVE = "save",
	STORAGE = "storage",
	TIMER = "timer",
	CENTER = "center",
	REWARD = "reward",
	ARROW_LEFT = "arrow-left",
	ARROW_RIGHT = "arrow-right",
	PUT_IN_INVENTORY = "put-in-inventory",
	SEARCH = "search",
	MOVE = "move",
}

// TODO: rename
export const CurrencyTypesTranslation: Partial<Record<ResourceType, string>> = {
	[ResourceType.COINS]: "resource.coins",
	[ResourceType.FOOD_DIFF]: "resource.food",
	[ResourceType.POPULATION_DIFF]: "resource.workforce",
	[ResourceType.GEMS]: "resource.gems",
	[ResourceType.LUMBER]: "resource.lumber",
	[ResourceType.CLAY]: "resource.clay",
	[ResourceType.STONE]: "resource.stone",
	[ResourceType.GOODS]: "resource.goods",
	[ResourceType.IRON]: "resource.iron",
	[ResourceType.STEEL]: "resource.steel",
	[ResourceType.ARMY]: "resource.army",
	[ResourceType.SUPER_CLICKER]: "resource.superClicker",
	[ResourceType.AD_SKIPPER]: "resource.adSkipper",
	[ResourceType.EXPLORATION_SPEED]: "ui.exploration",
	[ResourceType.RATIONS]: "resource.rations",
};

export enum ResourceChangeHighlight {
	POSITIVE = "positive",
	NEGATIVE = "negative",
}

export enum FontWeights {
	REGULAR = 400,
	BOLD = 800,
}

export enum StatusTypes {
	DEFAULT_ACTIVE = "default-active",
	DEFAULT = "default",
	SUCCESS = "success",
	WARNING = "warning",
	DANGER = "danger",
	INFO = "info",
	PRIMARY = "primary",
	SECONDARY = "secondary",
}

export enum UIContexts {
	BASE = "base",
	SETTLEMENT = "settlement",
	LEVEL_UP = "level-up",
	UNLOCK_HISTORY = "unlock-history",
	SEARCH = "search",
}

export enum SkinTypes {
	DARK = "dark",
	LIGHT = "light",
	PREMIUM = "premium",
	TRANSPARENT = "transparent",
	EVENT = "event",
}

export enum TileUpgradeBoxTypes {
	LIST = "list",
	GRID = "grid",
}

export enum TileUpgradeBoxSkinTypes {
	TERRAIN = "terrain",
	BUILDING = "building",
	BUILDING_PREMIUM = "building-premium",
	BUILDING_EVENT = "building-event",
	FRIENDLY_UNIT = "friendly-unit",
	DEFAULT = "default",
}

export enum ModalWindowSkinTypes {
	DEFAULT = "default",
	PREMIUM = "premium",
	EVENT = "event",
}

export enum Placements {
	BOTTOM = "bottom",
	LEFT = "left",
	RIGHT = "right",
	TOP = "top",
}

export enum MenuTileState {
	BASE = "base",
	PREMIUM = "premium",
	ACTIVE = "active",
}

export enum LabelThemes {
	GREEN = "green",
	LIGHT_GREEN = "light-green",
	MID_GREEN = "mid-green",
	PINE_GREEN = "pine-green",
	RED = "red",
	DARK_RED = "dark-red",
	RASPBERRY = "raspberry",
	VIOLET = "violet",
	PURPLE = "purple",
	BLUE = "blue",
	DARK_BLUE = "dark-blue",
	BRONZE = "bronze",
	GREY = "grey",
	BLACK = "black",
	MIDNIGHT_BLUE = "midnight-blue",
}

// Comsumption / income resources
export interface ResourceConsumptionSourceItem {
	sourceText: string;
	count: number;
	consumption: number;
}

export interface ResourceConsumption {
	type: string;
	value: number;
	storage: number;
	maxStorage?: number;
	consumptionSources: Array<ResourceConsumptionSourceItem>;
}
export interface ResourceIncomeSourceItem {
	sourceText: string;
	count: number;
	production: number;
}

export interface ResourceIncome {
	type: string;
	value: number;
	storage: number;
	maxStorage?: number;
	incomeSources: Array<ResourceIncomeSourceItem>;
}

// Settings
export enum GraphicDetails {
	LOW = "low",
	MEDIUM = "medium",
	HIGH = "high",
}

// Tutorial
export enum TutorialStepTypes {
	ARROW = "arrow",
	GLOW = "glow",
}

// Shop
export enum FiatCurrencies {
	AUD = "AUD",
	BGN = "BGN",
	BRL = "BRL",
	CAD = "CAD",
	CHF = "CHF",
	CNY = "CNY",
	CZK = "CZK",
	DKK = "DKK",
	EGP = "EGP",
	EUR = "EUR",
	GBP = "GBP",
	HKD = "HKD",
	HRK = "HRK",
	HUF = "HUF",
	IDR = "IDR",
	ILS = "ILS",
	INR = "INR",
	JPY = "JPY",
	KRW = "KRW",
	MXN = "MXN",
	MYR = "MYR",
	NOK = "NOK",
	NZD = "NZD",
	PHP = "PHP",
	PLN = "PLN",
	RON = "RON",
	RUB = "RUB",
	SEK = "SEK",
	SGD = "SGD",
	THB = "THB",
	TRY = "TRY",
	USD = "USD",
	ZAR = "ZAR",
}

export enum ShopBoxTypes {
	GOLD = "gold",
	SILVER = "silver",
	BRONZE = "bronze",
}

// TODO remove
export enum OfferType {
	STANDARD = "standard",
	GEM = "gem",
	STARTER = "starter",
	GOLDEN = "golden",
	BUILDING = "building",
	BLACK_FRIDAY = "black-friday",
	BLACK_FRIDAY_BUILDING = "bf-building",
	SUPER_CLICKER = "super_clicker",
	AD_SKIPPER = "ad_skipper",
	GEM_FOR_COINS = "gem_for_coins",
	COINS_FOR_GEMS = "coins_for_gems",
	RESOURCES_FOR_GEMS = "resources_for_gems",
	ACTION_FOR_GEMS = "action_for_gems",
	SPECIAL_BUILDING = "special_building",
	CHRISTMAS = "christmas",
	COINS_FOR_EVENTIUM = "coins_for_eventium",
	RESOURCES_FOR_EVENTIUM = "resources_for_eventium",
	SUPER_CLICKER_FREE = "super_clicker_free",
	VALENTINE = "valentine",
}

// SHRINK/RESIZE TEXT
export const FONT_SIZES = [
	6, 8, 10, 12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 34, 36, 38, 40, 44, 48,
	50, 60, 72, 90, 110,
];

export const ICON_SIZES = [32, 48, 56, 72, 80, 120, 184];

export const routesWithFixedModalHeight = {
	[RouteNames.INFO]: isMobile()
		? "calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem)"
		: "63vh",
	[RouteNames.SETTINGS]: "50vh",
};

export const routesWithMaxModalHeight = {
	[RouteNames.UPGRADES]: isMobile()
		? "calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem)"
		: "63vh",
	[RouteNames.QUESTS]: isMobile()
		? "calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem)"
		: "63vh",
	[RouteNames.SHOP]:
		// 2rem is an aesthetic fallback
		isMobile()
			? "calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem)"
			: "63vh",
	["any-70"]: isMobile()
		? `min(
				calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem),
				calc((100vh - var(--safe-area-inset-bottom)) * 0.70)
		)`
		: "63vh",
	["any-50"]: isMobile()
		? `min(
				calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem),
				calc((100vh - var(--safe-area-inset-bottom)) * 0.5)
		)`
		: "63vh",
	["any"]: isMobile()
		? "calc(100vh - var(--header-total-height) - var(--footer-height) - 2rem)"
		: "63vh",
};

export enum TextAlign {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right",
}

export interface News {
	title: string;
	text: string;
	date: Date;
}

export enum PromotionContext {
	DEFAULT = "default",
	BLACK_FRIDAY = "black-friday",
	CHRISTMAS = "christmas",
	EVENT = "event",
	SUMMER_SALE = "summer-sale",
	WINTER_SALE = "winter-sale",
	ANNIVERSARY = "anniversary",
	LIMITED = "limited",
	EXCLUSIVE = "exclusive",
	VALENTINE = "valentine",
}

export enum EventCategory {
	CHRISTMAS = "christmas",
	EASTER = "easter",
	FISHING = "fishing",
	FIREFEST = "firefest",
	SOLAR = "solarfair",
	HUNTING = "hunting",
	HALLOWEEN = "halloween",
	PIRATES = "pirates",
}

export enum EventStatus {
	INACTIVE = "inactive",
	SCHEDULED = "scheduled",
	LIVE = "live",
	ENDED_PENDING_CLEANUP = "ended_pending_cleanup",
}

export enum UniDirectionalLabelSkinTypes {
	RED = "red",
	GREEN = "green",
	GOLD = "gold",
}

export enum RewardsGridContext {
	POPUP = "popup",
	CARD = "card",
}

export enum ScrollDirection {
	HORIZONTAL = "horizontal",
	VERTICAL = "vertical",
}

export interface Tab {
	name: string; // Translation key (e.g., "ui.settings", "ui.info")
	icon?: string;
	slug?: string;
	showEventIcon?: boolean;
	hasNotification?: boolean;
	notificationCount?: number;
}

export enum ShopTab {
	REGULAR = "regular_shop",
	PREMIUM = "premium_shop",
	EVENT = "event",
}
